export function formatCompactNumber(num: number): string {
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1)}M`;
  if (num >= 1_000) return `${(num / 1_000).toFixed(1)}K`;
  return num.toLocaleString();
}

// OI is a count, never a currency — callers must NOT prefix the result with "$".
// Returns an em-dash whenever the value is missing or can't be parsed (e.g.
// the open-interest endpoint failed) so we render "—" instead of "NaN" or "".
export function formatOpenInterest(value: string | number | null | undefined): string {
  const num = typeof value === 'number' ? value : parseInt(value ?? '', 10);
  if (!Number.isFinite(num)) return '\u2014';
  return formatCompactNumber(num);
}
